<section>
  <h1>Create <span class="emphasis">Billing and Payment</span> Ticket</h1>

  @if (isLoading) {
    <div class="loading-indicator">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  } @else if (billTicketGroup) {
    <form
      [formGroup]="billTicketGroup"
      [ngClass]="{ 'form-submit-attempt': formSubmitAttempted }"
    >
      @if (invoices) {
        <h3 autocomplete="off">Invoice Date:</h3>
        <mat-form-field>
          <mat-label>Please select</mat-label>
          <mat-select
            formControlName="invoiceDate"
            (selectionChange)="canSubmit()"
          >
            @for (invoice of invoices; track invoice.ContentDocument.Title) {
              <mat-option [value]="invoice.ContentDocument.Title">
                {{
                  invoice.ContentDocument.Title.slice(0, 10) | date: 'longDate'
                }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (inlineErrors.invoiceDate) {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ inlineErrors.invoiceDate }}</div>
        </div>
      }

      <h3>Issue Summary</h3>
      <mat-form-field class="custom-textarea">
        <mat-label>Please describe your issue...</mat-label>
        <textarea
          matInput
          formControlName="summary"
          rows="5"
          (keyup)="canSubmit()"
        ></textarea>
      </mat-form-field>
      @if (inlineErrors.summary) {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ inlineErrors.summary }}</div>
        </div>
      }

      @if (submissionError) {
        <div
          [ngClass]="{
            'form-error': !errorMessage,
            'server-error': errorMessage,
          }"
        >
          <div class="custom-icon inline_error"></div>
          <div class="error-message">
            @if (!errorMessage) {
              <b>Error: </b> Unable to submit the ticket. Please try again!
            } @else {
              {{ errorMessage }}
            }
          </div>
        </div>
      }

      @if (isSubmitting) {
        <div class="loading-indicator">
          <mat-spinner [diameter]="25"></mat-spinner>
        </div>
      }

      <div class="flex justify-end mt-6">
        <button
          class="primary-button m-0"
          (click)="submitTicket()"
          [disabled]="isLoading || isSubmitting"
        >
          <span>Submit ticket</span>
        </button>
      </div>
    </form>
  }
</section>
